import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';


// import Sidebar from './Sidebar';
import Header from './Header';

const MainWrapper = experimentalStyled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
`
);

const MainContent = experimentalStyled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
);

const SidebarLayout = () => {
  return (
    <>
      {/* <Sidebar /> */}
      <MainWrapper>
        <Header />
        <MainContent>
          <Outlet />
        </MainContent>
      </MainWrapper>
    </>
  );
};

export default SidebarLayout;
